import { inject, Injectable } from '@angular/core';

import { Observable, take } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { DownloadSearch } from '../../entities/downloads/download-search.entity';
import { ExportEntity } from '../../entities/downloads/export-entity.entity';
import { PaginatedResults } from '../../record/entities/pagination/paginated-results.entity';
import { DownloadService } from '../services/download.service';

@Injectable()
export class DownloadsSandboxService {
    private readonly http: HttpClient = inject(HttpClient);

    constructor(private service: DownloadService) {}

    getDownloads(downloadSearch: DownloadSearch): Observable<PaginatedResults<ExportEntity>> {
        return this.service.getAll(downloadSearch);
    }

    public downloadUrl(url: string, filename: string): void {
        this.fetchBlob(url)
            .pipe(take(1))
            .subscribe(blob => {
                this.downloadBlob(blob, filename);
            });
    }

    private fetchBlob(url: string): Observable<Blob> {
        return this.http.get(url, {
            responseType: 'blob'
        });
    }

    private downloadBlob(blob: Blob, downloadTitle: string): void {
        const objectUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = objectUrl;

        a.download = downloadTitle;
        a.click();

        window.URL.revokeObjectURL(objectUrl);
    }
}
